import { useDarkStore, useDark as useDarkSelector } from "@client/store/dark";

export const useDark = () => {
  const dark = useDarkSelector();
  const toggleDark = useDarkStore((s) => s.toggleDark);
  return { dark, toggleDark };
};
